import { registerBlockType } from '@wordpress/blocks';
import { __ } from '@wordpress/i18n';
import Edit from './edit';
import Save from './save';
import metadata from './block.json';
import { GrDocumentText } from "react-icons/gr";
import './style.scss';
import './editor.scss';
import advancejson from '@vayu-blocks/advance-panel/advance.json';
import settings from './settings.json';
const { name } = metadata;

registerBlockType( name, {
	attributes: {
        ...metadata.attributes,
        ...advancejson,
        ...settings
    },
	icon: <GrDocumentText style={{color:'#6c1bc3'}} />,
    edit: Edit,
    save: Save,
} );